import { render, staticRenderFns } from "./adviceProject.vue?vue&type=template&id=d1266e06&scoped=true&lang=html&"
import script from "./adviceProject.vue?vue&type=script&lang=js&"
export * from "./adviceProject.vue?vue&type=script&lang=js&"
import style0 from "./adviceProject.vue?vue&type=style&index=0&id=d1266e06&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1266e06",
  null
  
)

export default component.exports